import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Home from '../components/Home';
import Sectors from '../components/Sectors';
import Services from '../components/Services';
import ProjectSection from '../components/ProjectSection';
import RegistrationSection from '../components/RegistrationSection';
import WhyFatlSection from '../components/WhyFatlSection';
import Footer from '../components/Footer';

const LandingPage = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timeoutId = setTimeout(() => setIsLoading(false), 1200);
    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <div>
      {isLoading && (
        <div className="initial-loading-overlay">
          <div className="initial-loading-spinner" />
          <div className="initial-loading-text">جاري التحميل...</div>
        </div>
      )}
      <div
        className="main-background"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundImage: "url('/Background.png')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          zIndex: -1
        }}
      />
      <Header />
      <Home />
      <Sectors />
      <Services />
      <ProjectSection />
      <RegistrationSection />
      <WhyFatlSection />
      <Footer />
    </div>
  );
};

export default LandingPage;


